<app-dynamic-form title="Beneficiary" [input]="data!" (result)="doHandleResult($event)"></app-dynamic-form>
